import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import CityList from './city-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Cities">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >Master Data</Breadcrumb.Item>
            <Breadcrumb.Item active>Cities</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <CityList />
    </Panel>
  );
};

export default Page;
